import React, { useState, useEffect } from   'react';
import { NavLink} from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { useForm } from 'react-hook-form';
import apiService from '../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip'; 
import { BotonEditar } from '../Utils/BotonEditar';
import { useAuth } from '../../Auth/AuthContext';
import RowV from '../Utils/RowStyled';
function BotonAcciones(row, Editar) {
        return (
            <BotonEditar Editar={Editar} row={row}></BotonEditar>
        );
    }
export default function Actividades(){
    const [cargando, setCargando] = useState(false);
    const { token } = useAuth();
    const [datos, setDatos] = useState([]);
    const { handleSubmit, register, setValue, formState: { errors }} = useForm();
    const [muestraFormulario, setMuestraFormulario] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    
    const columns = [
        {
            name: 'Acciones',
            cell: row => BotonAcciones(row, Editar),
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'Id', selector: row => row.id, sortable: true, width:'10%' },
        { name: 'Actividad', selector: row => row.actActividad, sortable: true, width: '25%'},
        { name: 'Estado', selector: row => row.actActivo?'Activo':'Inactivo', sortable: true, width: '7%' }
        ];
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = async () => {
        let url = `/parametros/listaractividaeses`;
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setDatos(result);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    function Editar (row){
        setMuestraFormulario(true);
        setValue('id', row.id);
        setValue('actActividad', row.actActividad);
        setValue('actActivo', row.actActivo);
    };
    const Nuevo = () =>  {
        setValue('id', 0);
        setValue('actActividad', '');
        setValue('actActivo', false);
        setMuestraFormulario(true);
    }
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/parametros/guardaractividad';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar', JSON.stringify(response.data));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            fetchData();
            ResetForm();
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        setValue('id', 0);
        setValue('actActividad', '');
        setValue('actActivo', false);
        setMuestraFormulario(false);
    }
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Parametros actividades</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={`/`} >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to={`/parametros`} >Parametros</NavLink></li>
                        <li className="breadcrumb-item active"> Actividades </li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {muestraFormulario && <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario</h3>
                                
                            </div>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    
                                    <input hidden {...register('id')}/>
                                    <RowV>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='actividad'>Actividad</label>
                                                <input id="actividad" className="form-control" placeholder="Actividad" {...register('actActividad', { required: true })}/>
                                                {errors.actActividad && <p style={{color: 'red'}}>Digitar dato</p>}
                                            </div>  
                                        </div>
                                    </RowV>
                                    <RowV>
                                        <div className='col-md-3'>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('actActivo')}
                                                    className="custom-control-input" id="SwitchEstado"/>
                                                <label className="custom-control-label" htmlFor="SwitchEstado">Estado</label>
                                                </div>
                                            </div>
                                        </div>
                                    </RowV>
                                </div>
                                <div className="card-footer">
                                    <RowV>
                                        <div className='col-md-1'>
                                            <button type="submit" className="btn btn-info">Guardar</button>
                                        </div>
                                    </RowV>
                                </div>
                            </form>
                        </div>
                    }   
                    <div className="card card">
                        <div className="card-body">
                            <div className="card-body table-responsive p-0">
                                <button className='form-control' onClick={Nuevo}>Nuevo</button>
                                <DataTable
                                    title="Actividades"
                                    columns={columns}
                                    data={datos}
                                    progressPending={cargando}
                                    pagination
                                    noDataComponent="No hay datos para mostrar"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}